export enum FormAccessPermission {
  Anonymous = 'anonymous',
  // Authenticated is not supported yet, pending full stageboekjes implementation
  // Authenticated = 'authenticated',
  TokenHolder = 'token_holder',
}

export interface Form extends ApiEntity {
  // The form "identifier" aka id of the form
  identifier: string
  // The organization that owns the form
  organizationId?: id
  // The title of the form
  title: string
  // The description of the form
  description?: string
  // The access permissions of the form
  accessPermission: FormAccessPermission
  // Configuration for the intro modal
  introModalConfig?: {
    // The title of the intro modal
    title: string
    // The body (markdown) of the intro modal
    body: string
  }
  // Success message config
  successMessageConfig?: {
    // The title of the success message
    title: string
    // The sub title of the success message
    subTitle: string
    // The body (markdown) of the success message
    body: string
    // Show thank you gif
    thankYouGif: boolean
    // The button of the success message
    button?: {
      // The text of the button
      text: string
      // The link of the button
      to: string
    }
  }
}

export function useFetchForm(id: id) {
  return useJsonApiFetch<Form & { formQuestions: FormQuestion[] }>(`/api/v1/forms/${id}?include=form_questions`)
}

export interface FormAccessToken extends ApiEntity {
  formSubmissionId: id
  token: string
  accessType: FormAccessTokenType
}

export enum FormAccessTokenType {
  Read = 'read',
  Write = 'write',
}

// Admins

export function useFetchForms() {
  return useJsonApiFetch<(Form & { formQuestions: FormQuestion[] })[]>(`/api/v1/forms/?include=form_questions`)
}

// Add _destroy to the form question input to allow for deletion
type FormQuestionInput = Partial<FormQuestion> & {
  _destroy?: boolean
}

export async function createForm(form: Partial<Form>, formQuestions: Partial<FormQuestionInput>[]) {
  // TODO: we should include relationships according to the JSON:API spec
  // const tempIdForIndex = (index: number) => `temp-${index + 1}`

  // const relationships = {
  //   form_questions: {
  //     // data: payload.formQuestions.map((_, index) => ({ type: 'form_questions', id: tempIdForIndex(index) })),
  //     data: payload.formQuestions, // .map((_, index) => ({ type: 'form_questions' })),
  //   },
  // }

  return await $api<Form & { formQuestions: FormQuestion[] }>('/api/v1/forms', {
    method: 'POST',
    body: {
      data: {
        type: 'form',
        attributes: { ...form },
        // relationships,
      },
      included: formQuestions.map((question, index) => ({
        type: 'form_questions',
        // id: tempIdForIndex(index),
        attributes: { ...question },
      })),
    },
    deserialize: true,
  })
}

export async function updateForm(id: id, form: Partial<Form>, formQuestions: Partial<FormQuestionInput>[]) {
  return $api<Form>(`/api/v1/forms/${id}`, {
    method: 'PATCH',
    body: {
      data: {
        type: 'form',
        attributes: { ...form },
        // TODO: we should include relationships, see notes in createForm
        // relationships:
      },
      included: formQuestions.map((question, index) => ({
        type: 'form_questions',
        id: question.id, // undefined for new questions
        attributes: { ...question },
      })),
    },
  })
}

export async function deleteForm(id: id) {
  return $api(`/api/v1/forms/${id}`, {
    method: 'DELETE',
  })
}
